module.exports = __webpack_public_path__ + "img/boots.4f9eacc6.svg";